import React, {useEffect, useRef, useState} from 'react';
import {Button, Form, Input, Modal} from 'antd';
import Pallet from "../../http_request/Model/pallet/Pallet";
import PrintPage from "../PalletIdProduction/PrintPage";
import {useReactToPrint} from "react-to-print";
import {useDispatch} from "react-redux";
import {getAgainHandler} from "../../store/TableRedux/TableRedux";

const PrintModal = ({data}) => {
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const printRef = useRef()
    const [open, setOpen] = useState(false);
    const [dataArray, setDataArray] = useState([]);
    const showModal = () => {
        setOpen(true);
    };

    const handleCancel = () => {
        setOpen(false);
        dispatch(getAgainHandler())
    };

    const onFinishFailed = (errorInfo) => {
    };

    const showPrint = useReactToPrint({
        content: () => printRef.current,
    });
    const onFinish = (values) => {


        Pallet.request({
            beforeSend: () => {
                setLoading(true)
            }, success: (result) => {
                setDataArray(result)
                // dispatch(getAgainHandler())


            }, final: () => {
                setLoading(false)
            }


        }).addParams({Verif: values.Verif}).PrintQueue(data.id)
    };
    useEffect(() => {
        if (dataArray.length) {

            setTimeout(() => {
                    showPrint()
                    // handleCancel()
                }
                , 10);

        }
    }, [dataArray,showPrint]);
    return (
        <>


            <Button className='defBtn blueBtn !px-4' onClick={showModal}>
                چاپ</Button>
            <Modal
                open={open}
                title="کد تایید"
                onOk={onFinish}
                onCancel={handleCancel}
                footer={null}
            >
                <Form
                    name="basic"
                    layout='vertical'
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >
                    <Form.Item
                        name="Verif"
                        label="کد تایید"
                        rules={[
                            {
                                required: true,
                                message: 'لطفا کد تایید را وارد کنید!',
                            },
                        ]}

                    >
                        <Input type='number'/>

                    </Form.Item>


                    <Form.Item>
                        <div className="flex justify-end gap-2">
                            <Button key="back" className='defBtn shadow-md bg-gray-100 ' onClick={handleCancel}>
                                انصراف
                            </Button>
                            <Button className='defBtn blueBtn' type="primary" htmlType="submit" loading={loading}>
                                ثبت
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
                <div ref={printRef} className="print-source">
                        {
                            dataArray.map((item, index) => (
                                <PrintPage key={index} data={item} numberPerPallet={item.numberPerPallet}/>
                            ))
                        }

                    </div>

            </Modal>

        </>
    );
};
export default PrintModal;